// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
import { z } from "zod";

export const HomeSearch = z.object({
  role: z.string().max(60).optional().catch(undefined),
  week: z.enum(["this", "last", "next"]).optional().catch(undefined),
});
export type HomeSearch = z.infer<typeof HomeSearch>;
